module.exports = __webpack_public_path__ + "img/img13.d38a8723.png";